export interface MediaOutAnimationComposition {
	property: string;
	from: number;
	to: number;
	durationInFrames: number;
	delay?: number;
	ease: (input: number) => number;
	easing: string;
	previewUrl: string;
	name: string;
}

export interface MediaOutAnimationPreset {
	name: string;
	composition: MediaOutAnimationComposition[];
}

function linearEase(input: number): number {
	return input;
}

function smoothEase(input: number): number {
	return input * input * (3 - 2 * input);
}

/**
 * Shared media-safe out-animation presets used across editor/runtime mapping.
 */
export const mediaOutAnimationPresets: Record<string, MediaOutAnimationPreset> = {
	fadeOut: {
		name: "fadeOut",
		composition: [
			{
				property: "opacity",
				from: 1,
				to: 0,
				durationInFrames: 15,
				ease: linearEase,
				easing: "linear",
				previewUrl: "https://cdn.designcombo.dev/animations/FadeOut.webp",
				name: "Fade",
			},
		],
	},
	scaleOut: {
		name: "scaleOut",
		composition: [
			{
				property: "scale",
				from: 1,
				to: 0,
				durationInFrames: 15,
				ease: smoothEase,
				easing: "ease",
				previewUrl: "https://cdn.designcombo.dev/animations/ScaleOut.webp",
				name: "Scale",
			},
		],
	},
	slideOutRight: {
		name: "slideOutRight",
		composition: [
			{
				property: "translateX",
				from: 0,
				to: -50,
				durationInFrames: 15,
				delay: 0,
				ease: smoothEase,
				easing: "ease",
				previewUrl: "https://cdn.designcombo.dev/animations/SlideOutRight.webp",
				name: "Slide Right",
			},
		],
	},
	slideOutLeft: {
		name: "slideOutLeft",
		composition: [
			{
				property: "translateX",
				from: 0,
				to: 50,
				durationInFrames: 15,
				delay: 0,
				ease: smoothEase,
				easing: "ease",
				previewUrl: "https://cdn.designcombo.dev/animations/SlideOutLeft.webp",
				name: "Slide Left",
			},
		],
	},
	slideOutTop: {
		name: "slideOutTop",
		composition: [
			{
				property: "translateY",
				from: 0,
				to: 50,
				durationInFrames: 15,
				delay: 0,
				ease: smoothEase,
				easing: "ease",
				previewUrl: "https://cdn.designcombo.dev/animations/SlideOutUp.webp",
				name: "Slide Top",
			},
		],
	},
	slideOutBottom: {
		name: "slideOutBottom",
		composition: [
			{
				property: "translateY",
				from: 0,
				to: -50,
				durationInFrames: 15,
				delay: 0,
				ease: smoothEase,
				easing: "ease",
				previewUrl: "https://cdn.designcombo.dev/animations/slideOutDown.webp",
				name: "Slide Bottom",
			},
		],
	},
};

export const mediaOutAnimationPresetList = Object.values(
	mediaOutAnimationPresets,
);
